import { InjectionToken } from '@angular/core';
import { isEmpty } from '@sama/micro-dash';
import { ContentConnector } from '../../../../team-apis/content/content-connector';
import { PointCloudAnswer } from '../../../../team-apis/otterdam/answers/point-cloud-answer';
import { VideoAnswer } from '../../../../team-apis/otterdam/answers/video-answer';

export const contentConnectorToken = new InjectionToken<ContentConnector>(
  'content connector token',
);

/**
 * Use this instead of `{}` when trying to check if something is empty
 * https://stackoverflow.com/a/52169540/13723409
 */
type EmptyObject = StrictRecord<string, never>;

export function isBlankAnswer(
  answer: PointCloudAnswer | VideoAnswer | undefined,
): answer is EmptyObject | undefined {
  return isEmpty(answer);
}
